// extracted by mini-css-extract-plugin
export var collapsedSummary = "_on-0";